import { PaymentMethod } from './payment.model';
import { Image } from './image.model';

export enum RentalStatus {
  ISSUED = 'issued',
  RETURNED = 'returned',
}

export interface RentalExtraService {
  id: number;
  service: number;
  name: string;
  amount: string; // decimal as string from backend
}

export interface Rental {
  id: number;
  booking: number | null;
  booking_id: number | null;
  client: number;
  client_name: string;
  client_phone: string;
  car: number;
  car_title: string;
  license_plate?: string;
  status: RentalStatus;
  status_display: string;
  mileage_before: number;
  mileage_after: number | null;
  handover_location: string;
  handover_datetime: string;
  return_location: string;
  return_datetime: string | null;
  expected_return_datetime: string | null;
  fuel_level_before: number | null;
  fuel_level_after: number | null;
  distance: number | null;
  mileage_overrun: number | null;
  fuel_consumed: number | null;
  car_mileage_limit?: number | null;
  notes: string;
  route: string;
  images_before: Image[];
  images_after: Image[];
  extra_services?: RentalExtraService[];
  created: string;
  modified: string;
}

export interface RentalList {
  id: number;
  client_name: string;
  car_title: string;
  license_plate?: string;
  status: RentalStatus;
  handover_datetime: string;
  return_datetime: string | null;
  expected_return_datetime: string | null;
}

export interface RentalCreate {
  client: number;
  car: number;
  booking?: number | null;
  handover_location: string;
  handover_datetime: string;
  mileage_before?: number;
  fuel_level_before?: number | null;
  expected_return_datetime?: string | null;
  notes?: string;
  route?: string;
  payment_amount?: string | number | null;
  payment_method?: PaymentMethod | null;
  images_before?: number[];
  images_after?: number[];
  extra_services?: { service: number; amount: number | string }[];
}

export interface RentalReturn {
  mileage_after: number;
  return_location: string;
  return_datetime: string;
  fuel_level_after?: number | null;
  images_after?: number[];
  extra_services?: { service: number; amount: number | string }[];
}

export interface RentalUpdate {
  mileage_before?: number;
  mileage_after?: number | null;
  handover_location?: string;
  handover_datetime?: string | null;
  return_location?: string;
  return_datetime?: string | null;
  expected_return_datetime?: string | null;
  fuel_level_before?: number | null;
  fuel_level_after?: number | null;
  notes?: string;
  route?: string;
  images_before?: number[];
  images_after?: number[];
  extra_services?: { service: number; amount: number | string }[];
}
